<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeCheckmarkCircle from "@dsk/icons/LeCheckmarkCircle.vue";
import { computed, ref } from "vue";
import { useToast } from "vue-toastification";

import LeCompanyDictionarySuggestionModal from "@/components/company-dictionary-suggestion/LeCompanyDictionarySuggestionModal.vue";
import { DictionariesHelper } from "@/helpers";

const props = defineProps<{
  dictionaryId: string;
}>();

const toast = useToast();

const buttonText = computed(() => {
  if (props.dictionaryId === DictionariesHelper.DANSKE_BANK_TERMS_DICTIONARY_ID) {
    return "Suggest new Danske Bank term";
  }
  return "Suggest term";
});

const tooltipText = computed(() => {
  if (props.dictionaryId === DictionariesHelper.DANSKE_BANK_TERMS_DICTIONARY_ID) {
    return "Send new term or feedback to Danske Bank";
  }
  return "Suggest new term to Nordea terms";
});

const isCompanyDictionarySuggestionModalOpen = ref<boolean>(false);

const onCompanySuggestionModalClose = (didSubmit: boolean) => {
  isCompanyDictionarySuggestionModalOpen.value = false;

  if (didSubmit) {
    toast("Thank you for your input"), { icon: LeCheckmarkCircle };
  }
};
</script>

<template>
  <div>
    <LeTooltip :text="tooltipText" :margin-bottom="10">
      <LeButton variant="outline" @click="isCompanyDictionarySuggestionModalOpen = true">
        <span>{{ buttonText }}</span>
      </LeButton>
    </LeTooltip>

    <LeCompanyDictionarySuggestionModal
      :dictionary-id="props.dictionaryId"
      :is-open="isCompanyDictionarySuggestionModalOpen"
      @close="onCompanySuggestionModalClose($event)"
    />
  </div>
</template>
